var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.12647 0H1.53642C0.905728 0 0.396606 0.555062 0.396606 1.23836V15.7629C0.396606 16.4456 0.905728 17 1.53642 17H8.12647C8.75602 17 9.26628 16.4456 9.26628 15.7629V1.23836C9.26628 0.555062 8.75602 0 8.12647 0ZM3.20534 0.752059H6.4587C6.54089 0.752059 6.60767 0.885249 6.60767 1.05003C6.60767 1.21482 6.54089 1.34863 6.4587 1.34863H3.20534C3.12258 1.34863 3.05694 1.21482 3.05694 1.05003C3.05694 0.885249 3.12258 0.752059 3.20534 0.752059ZM4.83202 15.7777C4.43077 15.7777 4.10429 15.4234 4.10429 14.9873C4.10429 14.5512 4.43077 14.1981 4.83202 14.1981C5.23212 14.1981 5.5586 14.5512 5.5586 14.9873C5.5586 15.4234 5.23212 15.7777 4.83202 15.7777ZM8.41242 13.0712H1.25104V2.08953H8.41242V13.0712Z","fill":"white"}));
}

PhoneInline.defaultProps = {"width":"10","height":"17","viewBox":"0 0 10 17","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
